import { render, staticRenderFns } from "./template-work-orders.html?vue&type=template&id=37012cca&scoped=true&"
import script from "./template-work-orders.js?vue&type=script&lang=js&"
export * from "./template-work-orders.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37012cca",
  null
  
)

export default component.exports